"use client"

import { FC, ReactNode } from "react"
import type { SearchResult } from "./types"
import {
  CountText,
  ResultList,
  ResultRow,
  ResultTitle,
  ResultSummary,
} from "./styles"

interface ResultsListProps {
  count: ReactNode
  results: SearchResult[]
  onResultClick: (result: SearchResult) => void
}

const ResultsList: FC<ResultsListProps> = ({
  count,
  results,
  onResultClick,
}) => (
  <>
    <CountText>{count}</CountText>
    <ResultList>
      {results.map((result) => (
        <ResultRow
          key={result.url}
          href={result.url}
          onClick={() => onResultClick(result)}
        >
          <ResultTitle>{result.title}</ResultTitle>
          {result.description && (
            <ResultSummary>{result.description}</ResultSummary>
          )}
        </ResultRow>
      ))}
    </ResultList>
  </>
)

export default ResultsList
